module.exports = [
    {code: 'en', name: 'English', default: true},
    {code: 'en-US', name: 'English(US)', default: false},
    {code: 'ca-ES', name: 'Catalan(Spain)', default: false},
    {code: 'en-ES', name: 'English(Spain)', default: false},
    {code: 'es-ES', name: 'Spanish(Spain)', default: false},
];
